import { useMemo} from 'react';
import { READING_RANK } from '../../../lib/const';
import { useRef } from 'react';
import { Spring } from 'react-spring/renderprops-universal';
import { useQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';


const appleMap = [
        {x:53.448, y:29.629}, {x:29.310, y:23.148}, {x:51.724, y:18.518}, {x:22.413, y:33.333}, {x:43.103, y:34.259},
        {x:46.551, y:13.888}, {x:34.482, y:55.555}, {x:68.965, y:39.444}, {x:35.344, y:27.592}, {x:51.724, y:40.74},
        {x:30.172, y:37.962}, {x:72.413, y:25.925}, {x:60.344, y:59.259}, {x:43.103, y:22.037}, {x:33.620, y:12.962},
        {x:62.172, y:20.74}, {x:60.344, y:46.296}, {x:23.275, y:48.148}, {x:43.103, y:48.148}, {x:61.206, y:35.555},
        {x:48.275, y:55.555}, {x:55.172, y:9.259}, {x:31.034, y:46.296}, {x:68.965, y:48.148},
        {x:34.827, y:36.296}
];


export const  UserApple = ({userId}) => {
    const appleRef = useRef([]);
    
    const { data: apple, isLoading, isError } = useQuery({
        queryKey: ['user/apple', userId],
        queryFn: () => Api.get(`/api/book/apple/${userId}`),
        refetchOnMount:'always',
    });


    const rankData = useMemo(() => {
        if (isLoading) return null;
        if (isError) return null;
        let rank = READING_RANK.find(item => item.startNum <= apple?.data?.totalCount);
        const rankData = {levelStartApple: 0, levelAppleCount:0, levelMaxApple: 25, levelPercent: 0, levelName: "", rankStepNum: 0, rank: null};
        if (rank.rank < 7) {
            let appleSum = rank.startNum;
            while (rankData.rankStepNum < rank.steps.length) {
                appleSum += rank.steps[rankData.rankStepNum];
                if (apple?.data?.totalCount < appleSum) break;
                rankData.rankStepNum++;
            }
            
            rankData.levelStartApple = rankData.levelStartApple + appleSum - rank.steps[rankData.rankStepNum];
            rankData.levelAppleCount = apple?.data?.totalCount - rankData.levelStartApple;
            rankData.levelMaxApple = rank.steps[rankData.rankStepNum];
            rankData.levelPercent = rankData.levelAppleCount / rankData.levelMaxApple;
            rankData.levelName = `${rank.name} ${rankData.rankStepNum + 1}`;
            rankData.rank = rank;
        } else {
            rankData.levelName = rank.name;
            rankData.levelStartApple = rank.startNum;
            rankData.rankStepNum = Math.floor((apple?.data?.totalCount - rankData.levelStartApple) / 25);
            rankData.rank = rank;
        }

        return rankData;
    }, [apple, isLoading, isError]);

    const renderApple = useMemo(() => {
        if (rankData === null) return null;
        const apples = new Array(rankData.levelAppleCount).fill(0);

        return apples.map((_, idx) => {
            let pos = appleMap[idx];
            if (pos === undefined) return null;
            return <img src={`${process.env.PUBLIC_URL}/static/images/apple/apple_red.png`} className={`apple_img apple_${idx}`} key={idx} style={{ position: "absolute", left: pos.x + "%", top: pos.y + "%" }} alt="사과" ref={(el) => {appleRef.current[idx] = el;}} />;

        });
    }, [rankData]);


    const renderLevelItems = useMemo(() => {
        if (rankData === null) return null;
        
        let steps = new Array(rankData.rankStepNum).fill(0);
        let stepJewels = null;
        
        stepJewels = steps.map((_, idx) => {
            return <img src={`${process.env.PUBLIC_URL}/static/images/apple/a0${rankData.rank.rank}.png`} className={`apple_img apple_${idx}`} alt="보석" key={idx} style={{position: "absolute", width: 8.62 + "%", left: idx * 10.344 + 2.068 + "%", bottom: 1.481 + "%"}} />;
        });

        if (rankData.rank.rank === 7) {
            stepJewels = [ <img src={`${process.env.PUBLIC_URL}/static/images/apple/a07.png`} alt="보석" style={{position: "absolute", width: 8.62 + "%", left: 2.068 + "%", bottom: 1.481 + "%"}} /> ];
        }

        return stepJewels;
    }, [rankData]);


    const renderClouds = useMemo(() => {
        let clouds = new Array(6).fill(0);

        return clouds.map((_, idx) => {
            return <img src={`${process.env.PUBLIC_URL}/static/images/apple/cloud.png`} className={`cloud cloud_${idx}`} key={idx} alt="구름"/>;
        });
    }, []);
    
    return (
        <div className="appleTreeStage">
            {renderClouds}
            {renderApple}
            <img src={`${process.env.PUBLIC_URL}/static/images/apple/user_apple_tree.png`} className="apple_tree_img" alt="사과나무" />
            <img src={`${process.env.PUBLIC_URL}/static/images/apple/windmill.png`} className="windmill_img" alt="풍차" />
            <div className="year">
                <Spring from={{ number: 2000 }} to={{ number: isNaN(apple?.data?.year) ? 2000 : Number(apple?.data?.year) }} >
                     {props => Math.round(props.number) }
                </Spring>년
                </div>
            <div className="apple_count">
                <Spring from={{ number: 0 }} to={{ number: apple?.data?.totalCount || 0 }} >
                    {props => Math.round(props.number)}
                </Spring>
            </div>
            {
                rankData !== null &&
                <>
                    <div className="rank">
                        <img src={`${process.env.PUBLIC_URL}/static/images/user/b0${apple?.data?.appleRank + 1}.png`} alt="독서등급"/>
                        <p>{`${rankData.rank.name} ${rankData.rankStepNum}`}</p>
                    </div>
                    {
                        rankData.rank.rank < 7 &&
                        <div className="level">
                            <Spring from={{ number: 0 }} to={{ number: Number(rankData.levelAppleCount) }}>
                                {(props) => Math.round(props.number)}
                            </Spring> 
                            {` / ${rankData.levelMaxApple}`}
                        </div>
                    }
                </>
            }
            {renderLevelItems}
        </div>
    );
};